'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ifeisIsomorphic = require('ifeis-isomorphic');

var _scores = require('ifeis-isomorphic/lib/redux/actions/scores');

var _getScoresheet = require('ifeis-isomorphic/lib/redux/actions/scores/getScoresheet');

var _getScoresheet2 = _interopRequireDefault(_getScoresheet);

var _comments = require('ifeis-isomorphic/lib/redux/actions/comments');

var _events = require('ifeis-isomorphic/lib/redux/actions/events');

var _getDressChecks = require('ifeis-isomorphic/lib/redux/actions/dress-checks/getDressChecks');

var _getDressChecks2 = _interopRequireDefault(_getDressChecks);

var _createDressCheck = require('ifeis-isomorphic/lib/redux/actions/dress-checks/createDressCheck');

var _createDressCheck2 = _interopRequireDefault(_createDressCheck);

var _updateDressCheck = require('ifeis-isomorphic/lib/redux/actions/dress-checks/updateDressCheck');

var _updateDressCheck2 = _interopRequireDefault(_updateDressCheck);

var _deleteDressCheck = require('ifeis-isomorphic/lib/redux/actions/dress-checks/deleteDressCheck');

var _deleteDressCheck2 = _interopRequireDefault(_deleteDressCheck);

var _getAllEventScores = require('ifeis-isomorphic/lib/redux/actions/events/getAllEventScores');

var _getAllEventScores2 = _interopRequireDefault(_getAllEventScores);

var _mapStateToController = require('./mapStateToController');

var _mapStateToController2 = _interopRequireDefault(_mapStateToController);

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _adjudicators = require('../../../../../../adjudicators');

var _adjudicators2 = _interopRequireDefault(_adjudicators);

var _events2 = require('../../../../../../events');

var _events3 = _interopRequireDefault(_events2);

var _registrations = require('../../../../../../registrations');

var _registrations2 = _interopRequireDefault(_registrations);

var _focus = require('../../../../../../focus');

var _focus2 = _interopRequireDefault(_focus);

var _enterableElements = require('../../../../../../enterable-elements');

var _enterableElements2 = _interopRequireDefault(_enterableElements);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ONLY_WHITESPACE_REGEXP = /^[\r\n ]+$/;

var TabulationsReviewController = function () {
  function TabulationsReviewController($q, $ngRedux, $rootScope, $state, $mdDialog, $mdSidenav, fEventService, fRegistrationService, fPrompt, fFeisService, msgService, feis, event_id, source, metadata, isGod, $window) {
    _classCallCheck(this, TabulationsReviewController);

    this._svc = {
      $q: $q,
      $ngRedux: $ngRedux,
      $rootScope: $rootScope,
      $state: $state,
      $mdDialog: $mdDialog,
      $mdSidenav: $mdSidenav,
      fPrompt: fPrompt,
      fEventService: fEventService,
      fFeisService: fFeisService,
      fRegistrationService: fRegistrationService,
      msgService: msgService,
      $window: $window
    };
    this.loading = 0;
    this.feis = feis;
    this.roles = metadata.grants;
    this.event_id = event_id;
    this.source = source;
    this.$window = $window;
    var hasEditPermissions = isGod || this.roles.indexOf('chair') > -1 || this.roles.indexOf('tabulations') > -1;

    this._svc.$q.all([this._svc.$ngRedux.dispatch((0, _events.getEvent)(feis.id, event_id)), this._svc.$ngRedux.dispatch((0, _events.getParticipants)(feis.id, event_id)), this._svc.$ngRedux.dispatch((0, _getAllEventScores2.default)(feis.id, event_id))]);

    this._svc.$ngRedux.connect(function (state) {
      return (0, _mapStateToController2.default)(feis.id, event_id, state);
    })(this);

    // Set Read Only
    // if feis is finalized or user navigates from Scores page
    this.readOnly = !!feis.is_finalized || !hasEditPermissions || this.source.toLowerCase() === 'scores';
    this.isBulkEditFeatureSet = false;

    // Allow edit comments and edit dress check
    // if Feis has not been finalized
    // for Gods, Chair and Tabs roles
    this.canEditComments = !feis.is_finalized && hasEditPermissions;
    this.canEditDressCheck = !feis.is_finalized && hasEditPermissions;

    this.dialogForCommentsReleased = this._svc.$mdDialog.confirm().title('Are you sure?').textContent('The comments have not been released. Continue?').cancel('Cancel').ok('Yes');
  }

  _createClass(TabulationsReviewController, [{
    key: 'error',
    value: function error(msg) {
      this._svc.msgService.displayErrorMsg(msg);
    }
  }, {
    key: 'hasLowScores',
    value: function hasLowScores(person) {
      var q = false;
      angular.forEach(person.scores, function (score) {
        q = score.value < 50;
      });
      return q;
    }
  }, {
    key: 'personChange',
    value: function personChange(scoresheet, person) {
      var _this = this;

      if (person.$origCompetitor !== person.competitor) {
        var pid;
        this.persons.some(function (p) {
          if (person.competitor === p.competitor) {
            pid = p.id;
            return true;
          }

          return false;
        });

        if (!pid) {
          this.error('Competitor ${person.competitor} not registered for this competition.');
          person.competitor = person.$origCompetitor;
        } else if (scoresheet.scores.some(function (s) {
          return s.$origCompetitor === person.competitor;
        })) {
          this.error('You have already entered scores for ' + person.competitor + '.');
          person.competitor = person.$origCompetitor;
        } else {
          // assign new id
          person.person = pid;

          // delete old scores
          return this._deleteScores(person).then(function () {
            person.$origCompetitor = person.competitor;

            // save new scores
            return _this._svc.$q.all(person.scores.map(function (s) {
              return _this._svc.$ngRedux.dispatch((0, _scores.createScore)(_this.feis.id, _this.event_id, s.adjudicator, pid, {
                round: s.round,
                value: s.value
              }));
            }));
          }).then(function (scores) {
            return person.scores = scores;
          }, function (err) {
            return _this.error(err);
          }).then(function () {
            return _this.scores.refreshScoresheet(scoresheet);
          });
        }
      }
    }
  }, {
    key: '_deleteScores',
    value: function _deleteScores(person) {
      var _this2 = this;

      return this._svc.$q.all(person.scores.map(function (s) {
        return _this2._svc.$ngRedux.dispatch((0, _scores.deleteScore)(_this2.feis.id, _this2.event_id, s.adjudicator, person.person, s.id));
      }));
    }
  }, {
    key: 'deletePerson',
    value: function deletePerson(person, aid) {
      var _this3 = this;

      return this._deleteScores(person).then(function () {
        // we want to delete comments only if scores get deleted.
        _this3._svc.$ngRedux.dispatch((0, _getScoresheet2.default)(_this3.feis.id, _this3.event_id, aid));
        if (person.comment) {
          _this3._svc.$ngRedux.dispatch((0, _comments.deleteComment)(_this3.feis.id, _this3.event_id, aid, person.person));
        }
        _this3._svc.$ngRedux.dispatch((0, _deleteDressCheck2.default)(_this3.feis.id, _this3.event_id, aid, person.person));
      }, function (err) {
        return _this3.error(err);
      });
    }
  }, {
    key: '_validateScore',
    value: function _validateScore(score) {
      return !isNaN(parseFloat(score.value)) && isFinite(score.value);
    }
  }, {
    key: 'updateScore',
    value: function updateScore(scoresheet, person, score) {
      if (!this._validateScore(score)) {
        this.error('Scores must be numbers.');
      } else {
        this._svc.$ngRedux.dispatch((0, _scores.updateScore)(this.feis.id, this.event_id, score.adjudicator, person.person, score.id, score));
        this.scores.refreshScoresheet(scoresheet);
      }
    }
  }, {
    key: 'updateComment',
    value: function updateComment(pid, aid, comment) {
      if (!comment) {
        return;
      }
      if (comment.id) {
        this._svc.$ngRedux.dispatch((0, _comments.updateComment)(this.feis.id, this.event_id, aid, pid, comment));
      } else {
        comment.text && this._svc.$ngRedux.dispatch((0, _comments.createComment)(this.feis.id, this.event_id, aid, pid, comment)) || Promise.resolve();
      }
    }
  }, {
    key: 'updateDressCheck',
    value: function updateDressCheck(pid, aid) {
      var dressCheck = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      dressCheck.dressCheck = dressCheck.dressCheck === 1 ? 0 : 1;

      if (dressCheck.id) {
        this._svc.$ngRedux.dispatch((0, _updateDressCheck2.default)(this.feis.id, this.event_id, aid, pid, dressCheck));
      } else {
        this._svc.$ngRedux.dispatch((0, _createDressCheck2.default)(this.feis.id, this.event_id, aid, pid, dressCheck));
      }
    }
  }, {
    key: 'sendToResults',
    value: function sendToResults($event) {
      var _this4 = this;

      var dialog = this._svc.$mdDialog.confirm().title('Are you sure?').textContent('Are you sure the scoresheets are accurate and ready to go to Awards?').cancel('Cancel').ok('Yes');

      this._svc.$mdDialog.show(dialog).then(function () {
        _this4._svc.$ngRedux.dispatch((0, _events.cachePlacements)(_this4.feis.id, _this4.event_id)).then(function () {
          return _this4._svc.$ngRedux.dispatch((0, _events.sendEventToResults)(_this4.feis.id, _this4.event_id, _this4.event.version_id));
        }).then(function () {
          return _this4._svc.$state.go('feiseanna.one.admin.tabulations', { feis: _this4.feis });
        }).catch(function (e) {
          if (e && e.errors && e.errors.status === 417) {
            var _ref = e.errors.data && e.errors.data.errors[0],
                title = _ref.title,
                detail = _ref.detail;

            _this4._svc.fAlert($event, title, detail);
          }
        });
        ;
      });
    }
  }, {
    key: 'isEventInCommentsReleasableState',
    value: function isEventInCommentsReleasableState() {
      return this.event.is_in_qa || this.event.is_in_results || this.event.is_announced || this.event.recall;
    }
  }, {
    key: 'toggleCommentsReleased',
    value: function toggleCommentsReleased() {
      var _this5 = this;

      if (this.isEventInCommentsReleasableState()) {
        this._svc.$ngRedux.dispatch((0, _events.updateReleaseComments)(this.feis.id, this.event_id, this.event.commentsReleased || 0)).then(function () {
          return _this5._svc.$ngRedux.dispatch((0, _events.getEvent)(_this5.feis.id, _this5.event_id));
        });
      } else {
        this.event.commentsReleased = 0;
        this._svc.msgService.displayErrorMsg("Comments cannot be released for an event unless scores have been entered and approved.");
      }
    }
  }, {
    key: 'showPerson',
    value: function showPerson(person) {
      this.currentPerson = person;
      this._svc.$mdSidenav('participant-sidenav').open();
    }
  }, {
    key: 'goBack',
    value: function goBack(e) {
      e.preventDefault();
      e.stopPropagation();

      var previousState = this._svc.$rootScope.previousState && this._svc.$rootScope.previousState;

      previousState && this._svc.$state.go(previousState) || this.$window.history.back();
    }
  }, {
    key: 'setBulkEditDressCheck',
    value: function setBulkEditDressCheck() {
      this.isBulkEditFeatureSet = !this.isBulkEditFeatureSet;
    }
  }, {
    key: 'setBulkEditComments',
    value: function setBulkEditComments() {
      this.isBulkEditFeatureSet = !this.isBulkEditFeatureSet;
    }
  }, {
    key: 'getEventName',
    value: function getEventName() {
      if (this.event) {
        return (0, _ifeisIsomorphic.getDescription)(this.event);
      }
    }
  }]);

  return TabulationsReviewController;
}();

exports.default = angular.module('ifeis.routes.feiseanna.one.admin.tabulations.review', ['ui.router', 'ifeis.adjudicators', 'ifeis.focus', 'ifeis.enterable.elements', 'ifeis.registrations', 'ifeis.events']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.review', {
    url: '/:source/review/:event',
    template: require('./tpl.html'),
    controller: TabulationsReviewController,
    controllerAs: 'ctrl',
    resolve: {
      event_id: function event_id($stateParams) {
        return $stateParams.event;
      },
      source: function source($stateParams) {
        return $stateParams.source;
      }
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/tabulations/review/index.js
// module id = 581
// module chunks = 0